import { axiosClient } from '../../../shared/api';

export const listDrivers = async (query = '') => {
  const response = await axiosClient.get(`/drivers${query}`);
  return response.data;
};

export const getDriverDetails = async (driverId) => {
  const response = await axiosClient.get(`/drivers/${driverId}`);
  return response.data;
};

export const createDriver = async (driverData) => {
  const response = await axiosClient.post('/drivers', driverData);
  return response.data;
};

export const updateDriver = async (driverId, updatedData) => {
  const response = await axiosClient.put(`/drivers/${driverId}`, updatedData);
  return response.data;
};
